var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagsIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C92A4",
    d: "M1.035 8.535 9.87 17.25c.28.27.654.42 1.043.42A1.499 1.499 0 0 0 12 17.25l5.295-5.302a1.5 1.5 0 0 0-.045-2.198L8.475 1.125l-.037-.045A2.835 2.835 0 0 0 6.645.33H1.77a1.5 1.5 0 0 0-1.5 1.5v4.92c.037.667.308 1.299.765 1.785Zm2.61-3.69a1.125 1.125 0 1 1 2.25.06 1.125 1.125 0 0 1-2.25-.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsIconGrey);
export default __webpack_public_path__ + "static/media/tags-icon-grey.caf8233cd8fa94a7c690f916ffc97a1a.svg";
export { ForwardRef as ReactComponent };